import { matchPath } from "react-router-dom";
import { AppRoutesConfig } from "./app.config";

export const ROLES = Object.freeze({
	XOOKEEPER_ADMIN: "admin",
	XOOKEEPER: "filler",
});

export const USER_FUNCTIONALITIES = Object.freeze({
	CREATE_PLAN: "CREATE_PLAN",
	REPLACE_PLAN: "REPLACE_PLAN",
	CANCEL_PLAN: "CANCEL_PLAN",
	ATTACH_TO_PLAN: "ATTACH_TO_PLAN",
	CREATE_INVENTORY_PLAN: "CREATE_INVENTORY_PLAN",
	EDIT_INVENTORY_PLAN: "CREATE_INVENTORY_PLAN",
	VIEW_INVENTORY_PLAN: "CREATE_INVENTORY_PLAN",
	REPLACE_INVENTORY_PLAN: "CREATE_INVENTORY_PLAN",
});

const ROLE_PERMISSIONS = Object.freeze({
	[ROLES.XOOKEEPER_ADMIN]: {
		allowedPages: "*"
	},
	[ROLES.XOOKEEPER]: {
		allowedPages: {
			[AppRoutesConfig.MACHINE.TASK.MANAGER.match]: true,
			[AppRoutesConfig.MACHINE_SELECT.match]: true,
		},
		blockedFunctions: [
			USER_FUNCTIONALITIES.CREATE_PLAN,
			USER_FUNCTIONALITIES.REPLACE_PLAN,
			USER_FUNCTIONALITIES.CANCEL_PLAN,
			USER_FUNCTIONALITIES.ATTACH_TO_PLAN,
			USER_FUNCTIONALITIES.CREATE_INVENTORY_PLAN,
			USER_FUNCTIONALITIES.EDIT_INVENTORY_PLAN,
			USER_FUNCTIONALITIES.VIEW_INVENTORY_PLAN,
			USER_FUNCTIONALITIES.REPLACE_INVENTORY_PLAN,
		],
	},
});

export function checkFunctionalityPermissions(role, functionality) {
	const blockedFunctions = ROLE_PERMISSIONS?.[role]?.blockedFunctions;
	if (!blockedFunctions) return ROLE_PERMISSIONS?.[role] ? true : false;

	return !blockedFunctions.includes(functionality);
}

export function canAccessLink(role, link) {
	const allowedPages = ROLE_PERMISSIONS?.[role]?.allowedPages;

	if (allowedPages && link) {
		if (allowedPages === "*") return true;

		for (const routePattern in allowedPages) {
			if (allowedPages[routePattern]) {
				// Check if access is allowed for this route pattern
				const match = matchPath({ path: routePattern, exact: false, strict: false }, link);
				if (match) {
					return true;
				}
			}
		}
	}

	return false;
}